import React from "react";
import Icon from "@material-ui/core/Icon";

const EditButton = (props) => {
  return (
    <button
      aria-label={`edit ${props.type}`}
      className="btn btn-link"
      style={{ display: "block" }}
      onClick={(e) => props.focus(props.parentKey, e)}
    >
      <Icon className="mr-2 text-primary">edit</Icon>
    </button>
  );
};

export default EditButton;
